<template>
  <v-snackbar
    :color="color"
    :timeout="closeable ? -1 : timeout || 5000"
    v-model="value"
    width="700px"
    @close="close"
  >
    <div>
      <v-btn
        v-if="closeable"
        x-small
        text
        fab
        @click="close"
        style="position: absolute; top: 1px; right: 1px;"
      >
        x
      </v-btn>
      <div class="mr-3">{{ message }}</div>
      <v-btn
        x-small
        class="mx-auto"
        light
        v-if="more"
        @click="openMore = !openMore"
      >
        {{ openMore ? 'Voir moins' : 'Voir plus' }}
      </v-btn>
      <v-card
        v-if="more && openMore"
        elevation="0"
        color="#f2f2f2"
        class="grey--text mt-2 px-1"
        width="640px"
        max-height="20vh"
        style="overflow:auto;"
      >
        <div v-for="(item, index) in more" :key="index">
          <span class="font-italic">{{ item.url }}</span>
          : {{ item.error }}
        </div>
      </v-card>
    </div>
  </v-snackbar>
</template>
<script>
import { createNamespacedHelpers } from 'vuex';

const { mapGetters, mapActions } = createNamespacedHelpers('snackbar');
export default {
  name: 'CustomSnackbar',
  computed: {
    ...mapGetters([
      'message',
      'more',
      'color',
      'isOpen',
      'timeout',
      'closeable',
    ]),
    value: {
      get() {
        return this.isOpen;
      },
      set() {
        return this.close();
      },
    },
  },
  data: () => ({ openMore: false }),
  methods: {
    ...mapActions(['setSnackbarClose']),
    close() {
      this.openMore = false;
      return this.setSnackbarClose();
    },
  },
};
</script>
